import React, { useCallback, useEffect, useState } from 'react';
import api from '../../../services/api';
import { Button } from '../../ui/button';
import { toast } from 'sonner';
import { FlaskConical, Loader2, Plus, Trash2 } from 'lucide-react';

/* Contas de teste (igual Oil Tycoon): jogam normalmente, mas ficam fora dos rankings e dos prêmios de ranking. */
export default function WbAdminTestAccounts() {
  const [rows, setRows] = useState(null);
  const [kako, setKako] = useState('');
  const [label, setLabel] = useState('');
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setRows((await api.get('/admin/wb/test-accounts')).data.rows || []); }
    catch { toast.error('Erro ao carregar contas de teste.'); setRows([]); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post('/admin/wb/test-accounts', { kako_id: kako.trim(), label: label.trim() });
      toast.success('Conta de teste adicionada — fora dos rankings.');
      setKako(''); setLabel(''); await load();
    } catch (err) { toast.error(err.response?.data?.detail || 'Erro ao adicionar.'); }
    setBusy(false);
  };
  const remove = async (id) => {
    if (!window.confirm(`Remover ${id} das contas de teste? Ela volta a contar nos rankings.`)) return;
    try { await api.delete(`/admin/wb/test-accounts/${id}`); toast.success('Removida.'); await load(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Erro ao remover.'); }
  };

  return (
    <div className="space-y-3" data-testid="wb-admin-test-accounts">
      <p className="text-xs text-slate-500"><FlaskConical className="mr-1 inline h-3.5 w-3.5" />Contas de teste jogam normalmente (recarga, passaporte, coleta), mas <b>não aparecem nos rankings nem recebem prêmios de ranking</b>.</p>
      <form onSubmit={add} className="flex flex-wrap items-end gap-2">
        <label className="text-xs font-bold text-slate-600">KAKO ID
          <input value={kako} onChange={(e) => setKako(e.target.value)} required placeholder="ex.: 10765749" className="mt-1 block h-9 w-40 rounded-lg border px-2 text-sm" data-testid="wb-test-account-kako" />
        </label>
        <label className="text-xs font-bold text-slate-600">Observação
          <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="ex.: conta do dono" className="mt-1 block h-9 w-56 rounded-lg border px-2 text-sm" data-testid="wb-test-account-label" />
        </label>
        <Button type="submit" size="sm" disabled={busy || !kako.trim()} className="bg-orange-500 text-white hover:bg-orange-600" data-testid="wb-test-account-add">
          {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Plus className="mr-1 h-4 w-4" />} Adicionar
        </Button>
      </form>
      {!rows ? <div className="flex justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-orange-500" /></div> : (
        <div className="overflow-x-auto rounded-xl border">
          <table className="w-full text-left text-xs">
            <thead className="bg-slate-50 text-[10px] uppercase text-slate-500">
              <tr><th className="px-2 py-2 font-bold">KAKO ID</th><th className="px-2 py-2 font-bold">Apelido</th><th className="px-2 py-2 font-bold">Observação</th><th className="px-2 py-2 font-bold">Por</th><th className="px-2 py-2" /></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="px-2 py-6 text-center text-slate-400">Nenhuma conta de teste.</td></tr>}
              {rows.map((r) => (
                <tr key={r.kako_id} className="border-t" data-testid="wb-test-account-row">
                  <td className="px-2 py-1.5 font-mono font-bold">{r.kako_id}</td>
                  <td className="px-2 py-1.5">{r.nickname || '-'}</td>
                  <td className="px-2 py-1.5">{r.label || '-'}</td>
                  <td className="px-2 py-1.5 text-slate-500">{r.created_by}</td>
                  <td className="px-2 py-1.5 text-right"><Button size="sm" variant="ghost" onClick={() => remove(r.kako_id)} data-testid={`wb-test-account-remove-${r.kako_id}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
